import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import CustomizedCheckbox from './CustomizedCheckbox';
import ClientProvider from './client';
export default createDemo(import.meta.url, CustomizedCheckbox, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/checkboxes/demos/customized/CustomizedCheckbox.tsx",
    "fileName": "CustomizedCheckbox.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import { styled } from '@mui/material/styles';\nimport Checkbox from '@mui/material/Checkbox';\nimport type { CheckboxProps } from '@mui/material/Checkbox';\n\nconst BpIcon = styled('span')(({ theme }) => ({\n  borderRadius: 3,\n  width: 16,\n  height: 16,\n  boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',\n  backgroundColor: '#f5f8fa',\n  backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',\n  '.Mui-focusVisible &': {\n    outline: '2px auto rgba(19,124,189,.6)',\n    outlineOffset: 2,\n  },\n  'input:hover ~ &': {\n    backgroundColor: '#ebf1f5',\n    ...theme.applyStyles('dark', {\n      backgroundColor: '#30404d',\n    }),\n  },\n  'input:disabled ~ &': {\n    boxShadow: 'none',\n    background: 'rgba(206,217,224,.5)',\n    ...theme.applyStyles('dark', {\n      background: 'rgba(57,75,89,.5)',\n    }),\n  },\n  ...theme.applyStyles('dark', {\n    boxShadow: '0 0 0 1px rgb(16 22 26 / 40%)',\n    backgroundColor: '#394b59',\n    backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))',\n  }),\n}));\n\nconst BpCheckedIcon = styled(BpIcon)({\n  backgroundColor: '#137cbd',\n  backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',\n  '&::before': {\n    display: 'block',\n    width: 16,\n    height: 16,\n    backgroundImage:\n      \"url(\\\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath\" +\n      \" fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 \" +\n      \"1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\\\")\",\n    content: '\"\"',\n  },\n  'input:hover ~ &': {\n    backgroundColor: '#106ba3',\n  },\n});\n\n// Inspired by blueprintjs\nfunction BpCheckbox(props: CheckboxProps) {\n  return (\n    <Checkbox\n      sx={{ '&:hover': { bgcolor: 'transparent' } }}\n      disableRipple\n      color=\"default\"\n      checkedIcon={<BpCheckedIcon />}\n      icon={<BpIcon />}\n      slotProps={{ input: { 'aria-label': 'Checkbox demo' } }}\n      {...props}\n    />\n  );\n}\n\nexport default function CustomizedCheckbox() {\n  return (\n    <div>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <BpCheckbox />\n      <BpCheckbox defaultChecked />\n      <BpCheckbox disabled />\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </div>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 77,
        "focusedLines": 3,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import { styled } from '@mui/material/styles';\nimport Checkbox from '@mui/material/Checkbox';\nimport type { CheckboxProps } from '@mui/material/Checkbox';\n\nconst BpIcon = styled('span')(({ theme }) => ({\n  borderRadius: 3,\n  width: 16,\n  height: 16,\n  boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',\n  backgroundColor: '#f5f8fa',\n  backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',\n  '.Mui-focusVisible &': {\n    outline: '2px auto rgba(19,124,189,.6)',\n    outlineOffset: 2,\n  },\n  'input:hover ~ &': {\n    backgroundColor: '#ebf1f5',\n    ...theme.applyStyles('dark', {\n      backgroundColor: '#30404d',\n    }),\n  },\n  'input:disabled ~ &': {\n    boxShadow: 'none',\n    background: 'rgba(206,217,224,.5)',\n    ...theme.applyStyles('dark', {\n      background: 'rgba(57,75,89,.5)',\n    }),\n  },\n  ...theme.applyStyles('dark', {\n    boxShadow: '0 0 0 1px rgb(16 22 26 / 40%)',\n    backgroundColor: '#394b59',\n    backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))',\n  }),\n}));\n\nconst BpCheckedIcon = styled(BpIcon)({\n  backgroundColor: '#137cbd',\n  backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',\n  '&::before': {\n    display: 'block',\n    width: 16,\n    height: 16,\n    backgroundImage:\n      \"url(\\\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath\" +\n      \" fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 \" +\n      \"1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\\\")\",\n    content: '\"\"',\n  },\n  'input:hover ~ &': {\n    backgroundColor: '#106ba3',\n  },\n});\n\n// Inspired by blueprintjs\nfunction BpCheckbox(props: CheckboxProps) {\n  return (\n    <Checkbox\n      sx={{ '&:hover': { bgcolor: 'transparent' } }}\n      disableRipple\n      color=\"default\"\n      checkedIcon={<BpCheckedIcon />}\n      icon={<BpIcon />}\n      slotProps={{ input: { 'aria-label': 'Checkbox demo' } }}\n      {...props}\n    />\n  );\n}\n\nexport default function CustomizedCheckbox() {\n  return (\n    <div>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <BpCheckbox />\n      <BpCheckbox defaultChecked />\n      <BpCheckbox disabled />\n"
      ],
      [
        "span",
        "frame",
        "    </div>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 72
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "BpCheckbox"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 73
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "BpCheckbox"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "defaultChecked"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 74
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "BpCheckbox"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "disabled"
              ],
              " />"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 77,
    "focusedLines": 3,
    "collapsible": true,
    "externals": [
      "@mui/material/styles",
      "@mui/material/Checkbox"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
